var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-wrapper",attrs:{"name":"tabs"}},_vm._l((_vm.list),function(info,index){return _c('div',{key:("button_" + index),class:index === _vm.selectedIndex ? 'active-button' : 'inactive-button',on:{"click":function($event){return _vm.onClick(index)}}},[_vm._v("\n        "+_vm._s(info)+"\n    ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-081f40a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/Tabs.vue
// module id = null
// module chunks = 